import { Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { BrowsedJobDetailsContainerStyled } from './style';

type Props = {
  buildingId: string;
  buildingName: string;
  addressOfProperty: string;
};

const PropertyInformation = ({ addressOfProperty, buildingName }: Props) => {
  // const navigate = useNavigate();

  // const navigateToBuilding = () => {
  //   navigate(BUILDING_ROUTE);
  // };

  return (
    <BrowsedJobDetailsContainerStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        PROPERTY INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Building Name :</Typography>
          <Typography className="value">{buildingName}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Address of Property :</Typography>
          <Typography className="value">{addressOfProperty}</Typography>
        </InfoRowStyled>

        {/* <ButtonEndContainerStyled>
          <Button
            variant="gray"
            size="xs"
            onClick={navigateToBuilding}
            color="#000000"
          >
            View Property
          </Button>
        </ButtonEndContainerStyled> */}
      </VerticalSpaceStyled>
    </BrowsedJobDetailsContainerStyled>
  );
};

export default PropertyInformation;
